<template>
  <div class="itemBottom" :class="{ isActive }">
    <div class="card-bottom" ref="card">
      <div class="contents">
        <div class="contents-inner">
          <p>{{ data.ec_catch_copy }}</p>
        </div>
      </div>
      <div class="contents">
        <div class="contents-inner review-wrapper">
          <Review
            :id="data.pool_code"
            :poolCode="data.pool_code"
            :twoColumn="isSpView"
            :analyticsPrefix="'review'"
          />
        </div>
      </div>
      <div class="contents">
        <div class="contents-inner">
          <p class="price">
            <span class="price-number">{{
              data.komi_kkk | toLocaleString
            }}</span
            >円 (税込)
          </p>
        </div>
      </div>
      <div class="contents">
        <div class="contents-inner">
          <p>{{ data.hyoji_yo_naiyo_ryo }}</p>
        </div>
      </div>
      <div class="contents">
        <div class="contents-inner">
          <div class="brand">
            <div class="brand-image">
              <img
                :src="`assets/dist/static_image/brand/img_brand_${data.brand_code}.jpg`"
                alt=""
                width="200"
                height="260"
                loading="lazy"
              />
            </div>
            <a
              :href="`https://www.shiseido.co.jp/sw/c/products/SWFG070210.seam?zbr=${data.brand_code}&online_shohin_ctlg_kbn=1`"
              target="_blank"
              class="brand-link"
              @click="(e) => handleClickBrandLink(e)"
              >ブランド紹介ページ</a
            >
          </div>
        </div>
      </div>
      <div class="contents">
        <!-- <div class="contents-inner"> -->
        <ul class="contents-inner award" v-if="data.jushou.length !== 0">
          <li
            class="award-text"
            v-for="(prize, index) in data.jushou"
            :key="index"
          >
            {{ prize }}
          </li>
        </ul>
        <BlankIcon v-else />
        <!-- </div> -->
      </div>
      <div class="contents">
        <div class="contents-inner">
          <p v-if="worriesText">{{ worriesText }}</p>
          <BlankIcon v-else />
        </div>
      </div>
      <div class="contents">
        <div class="contents-inner">
          <p v-if="kinouCodeText">{{ kinouCodeText }}</p>
          <BlankIcon v-else />
        </div>
      </div>
      <div class="contents">
        <div class="contents-inner">
          <p v-if="data.kikan">{{ data.kikan }}</p>
          <BlankIcon v-else />
        </div>
      </div>
      <div class="contents">
        <div class="contents-inner">
          <p v-if="data.shiyou_kansyoku">{{ data.shiyou_kansyoku }}</p>
          <BlankIcon v-else />
        </div>
      </div>
      <div class="contents">
        <div class="contents-inner">
          <p v-if="kaoriText">{{ kaoriText }}</p>
          <BlankIcon v-else />
        </div>
      </div>
      <div class="contents">
        <div class="contents-inner">
          <p class="circleIcon" v-if="data.iyaku_bugaihin">○</p>
          <BlankIcon v-else />
        </div>
      </div>
      <div class="contents">
        <div class="contents-inner">
          <p v-if="seibunText">{{ seibunText }}</p>
          <BlankIcon v-else />
        </div>
      </div>
      <div class="contents">
        <div class="contents-inner">
          <p class="circleIcon" v-if="isAlcoholFree">○</p>
          <BlankIcon v-else />
        </div>
      </div>
      <div class="contents">
        <div class="contents-inner">
          <p class="circleIcon" v-if="isParabenFree">○</p>
          <BlankIcon v-else />
        </div>
      </div>
      <div class="contents">
        <div class="contents-inner">
          <p class="circleIcon" v-if="isOilFree">○</p>
          <BlankIcon v-else />
        </div>
      </div>
      <div class="contents">
        <div class="contents-inner">
          <p v-if="data.hanbai_meisyo_flg === 1">{{ data.hanbai_meisyo }}</p>
          <BlankIcon v-else />
        </div>
      </div>
      <div class="contents">
        <div class="contents-inner lineup">
          <ul class="link-list" v-if="data.lineups.length !== 0">
            <li
              class="link-item"
              v-for="lineup in data.lineups"
              :key="lineup.shohin_pl_c_cd"
            >
              <a
                class="link"
                :href="`https://www.shiseido.co.jp/sw/c/products/SWFG070410.seam?&shohin_pl_c_cd=${lineup.shohin_pl_c_cd}&online_shohin_ctlg_kbn=1`"
                target="_blank"
                @click="(e) => handleClickLineup(e, lineup.shohin_pl_c_cd)"
                >{{ lineup.shohin_name }}
              </a>
            </li>
          </ul>
          <BlankIcon v-else />
        </div>
      </div>
      <div class="contents">
        <div class="contents-inner">
          <p v-if="data.body_copy_link_text">
            <a
              class="link"
              :href="data.body_copy_link_url"
              target="_blank"
              @click="(e) => handleClickRefill(e)"
              >{{ data.body_copy_link_text }}</a
            >
          </p>
          <BlankIcon v-else />
        </div>
      </div>
      <div class="contents howto">
        <p
          v-if="isSerumCategory"
          class="howto-text"
          v-html="$sanitize(data.shiyou_houhou)"
        ></p>
        <BlankIcon v-else />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import BlankIcon from "./BlankIcon.vue";
import Review from "../../ui/Review.vue";
import { adobeClickEvent } from "../../../modules/analytics";

export default {
  name: "ItemBottom",
  components: { Review, BlankIcon },
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    isSerumCategory: {
      type: Boolean,
      default: false,
    },
    isSpView: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters("jsonData", ["tables", "forms"]),
    worriesText() {
      const worriesData = this.data.worries_some;
      if (!worriesData || worriesData.length === 0) return null;

      const worriesTable = this.tables.worries_some;
      const text = worriesData.reduce((text, currentValue, index) => {
        const currentText = worriesTable[currentValue];

        return index === 0 ? currentText : text + " / " + currentText;
      }, "");
      return text;
    },
    kinouCodeText() {
      const kinouCode = this.data.kinou_code;
      if (!kinouCode || kinouCode.length === 0) return null;

      const kinouCodeTables = this.tables.kinou_code;
      const text = kinouCode.reduce((text, currentValue, index) => {
        const currentText = kinouCodeTables[currentValue];
        const hashTagText = "#" + currentText;

        return index === 0 ? hashTagText : text + " " + hashTagText;
      }, "");
      return text;
    },
    kaoriText() {
      const kaoriCode = this.data.kaori;
      if (!kaoriCode) return null;
      const text = this.tables.kaori[kaoriCode];
      return text;
    },
    seibunText() {
      const seibunCode = this.data.seibun;
      if (!seibunCode || seibunCode.length === 0) return null;

      const seibunCodeTables = this.tables.seibun;
      const text = seibunCode.reduce((text, currentValue, index) => {
        const currentText = seibunCodeTables[currentValue];
        return index === 0 ? currentText : text + " / " + currentText;
      }, "");
      return text;
    },
    isAlcoholFree() {
      const table = this.tables.kinou_search;
      return this.data.kinou_search.some((keyValue) => {
        const valueName = table[keyValue];
        return valueName === "アルコールフリー";
      });
    },
    isParabenFree() {
      const table = this.tables.kinou_search;
      return this.data.kinou_search.some((keyValue) => {
        const valueName = table[keyValue];
        return valueName === "パラベンフリー";
      });
    },
    isOilFree() {
      const table = this.tables.kinou_search;
      return this.data.kinou_search.some((keyValue) => {
        const valueName = table[keyValue];
        return valueName === "オイルフリー";
      });
    },
  },
  methods: {
    analyze(eventId, url) {
      adobeClickEvent(eventId, url);
    },
    handleClickBrandLink(e) {
      const url = e.currentTarget.href;
      this.analyze(`brandshokai_${this.data.brand_code}`, url);
    },
    handleClickLineup(e, lineupPoolCode) {
      const url = e.currentTarget.href;
      this.analyze(`lineup_${lineupPoolCode}`, url);
    },
    handleClickRefill(e) {
      const urlString = e.currentTarget.href;
      const urlObj = new URL(urlString);
      const params = new URLSearchParams(urlObj.search);
      const refillPoolCode = params.get("shohin_pl_c_cd");
      if (refillPoolCode) this.analyze(`refill_${refillPoolCode}`, urlString);
    },
  },
};
</script>
<style lang="scss" scoped>
.itemBottom {
  $shadowColor: rgba(0, 0, 0, 0.05);
  $itemWidth: 220px;

  position: relative;
  z-index: 1;
  width: $itemWidth;
  padding-bottom: 20px;

  .card-bottom {
    width: 100%;
    border-radius: 0 0 10px 10px;
    border: 2px solid transparent;
    border-top: none;
    position: relative;
    box-shadow: 0 2px 10px 2px $shadowColor;
    background: rgba(255, 255, 255, 0.5);

    /* .is-acitve & {
      border: $borderSize solid $main-red;
      border-top: none;
    } */
  }

  .contents {
    /* min-height: 500px; */
  }
  .contents-inner {
    height: 100%;
    padding: 15px 20px;
    line-height: 1.4;
    text-align: left;
    word-break: break-all;
    font-size: 12px;

    &.review-wrapper {
      padding-right: 4px;
    }

    &.lineup {
    }
  }

  .price {
  }
  .price-number {
    font-size: 14px;
    font-weight: 600;
    color: #333;
  }

  .brand {
    width: 100%;
  }

  .brand {
  }

  .brand-image {
    width: 180px;
    margin: 0 auto;

    /* & > img {
      width: auto;
      margin: auto;
      object-fit: contain;
    } */
  }

  .brand-link {
    display: inline-block;
    width: 100%;
    margin-top: 15px;
    line-height: 1.2;
    text-align: center;
    text-decoration: underline currentColor;
    color: $main-red;
    opacity: 1;
    transition: opacity 0.3s $easing-color;
    @media (hover: hover) {
      &:hover {
        opacity: 0.6;
      }
    }
  }

  .award {
    width: 100%;
    max-height: 100px;
    overflow-y: scroll;
  }
  .award-text {
    display: flex;
    padding: 0;

    &::before {
      content: "";
      display: block;
      position: relative;
      top: 3px;
      width: 12px;
      height: 12px;
      flex-shrink: 0;
      background: url("../../../assets/images/_parts/other/award.svg") no-repeat
        center/contain;
      margin-right: 5px;
    }

    & + .award-text {
      margin-top: 8px;
    }
  }

  .howto {
    width: 100%;
    height: 200px !important;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
  }

  .howto-text {
    text-align: left;
    white-space: pre-wrap;
    padding: 15px 20px;
  }

  &.isActive {
    .card-bottom {
      border: 2px solid $main-red;
      border-top: none;
    }
  }

  .circleIcon {
    width: 100%;
    text-align: center;
  }

  .link-item {
    & + .link-item {
      margin-top: 4px;
    }
  }

  .link {
    color: $main-red;
    opacity: 1;
    transition: opacity 0.3s $easing-color;
    text-decoration: underline;
    margin: 0;
    @media (hover: hover) {
      &:hover {
        opacity: 0.6;
      }
    }
  }

  @include media() {
    $itemWidth: vw(120);

    width: $itemWidth;
    padding-bottom: vw(20);

    .card-bottom {
      border-radius: 0 0 vw(10) vw(10);
      box-shadow: 0 vw(0.25) vw(4) vw(2) $shadowColor;
    }

    .contents-inner {
      padding: vw(10);
      font-size: vw(10);
      &.review-wrapper {
        padding-right: vw(10);
      }
    }

    .price {
    }
    .price-number {
      font-size: vw(11);
    }

    .brand-image {
      width: vw(100);
    }

    .brand-link {
      display: inline-block;
      width: 100%;
      margin-top: vw(8);
    }

    .award {
      max-height: vw(100);
    }

    .award-text {
      &::before {
        width: vw(8);
        height: vw(8);
        margin-right: vw(2);
        top: vw(4);
      }
      & + .award-text {
        margin-top: vw(8);
      }
    }

    .link-item {
      & + .link-item {
        margin-top: vw(4);
      }
    }

    .howto-text {
      font-size: vw(10);
      padding: vw(10);
    }
  }
}
</style>
